import {
  Component,
  Input,
  Output,
  EventEmitter,
  Injector,
  ViewContainerRef,
  OnInit,
  OnChanges,
  OnDestroy,
  ComponentRef,
  Type,
  SimpleChanges,
  ViewChildren,
  AfterViewInit,
  QueryList,
  ComponentFactoryResolver,
} from '@angular/core';

interface GenericTab {
  component: Type<any>;
  label: string;
  inputs: Array<{ name: string; value: any }>;
  outputs: Array<string>;
}

//  <usimweb-tab-group [tabs]="dynamicLoader" (tabEvent)="getResultCurves($event)" ></usimweb-tab-group>

// <mat-tab-group>
//   <mat-tab *ngFor="let tab of tabs" [label]="tab.label">
//     <ng-template #comp></ng-template>
//   </mat-tab>
// </mat-tab-group>

// this.store.select(fromStore.getResult).subscribe((results) => {
//   if (results.results) {
//     this.dynamicLoader = [
//       {
//         component: ResultsChartComponent,
//         label: 'Result',
//         inputs: [
//           { name: 'data', value: results.results[0].data },
//           { name: 'layout', value: results.results[0].layout },
//         ],
//         outputs: ['selectedPlotTypeEvent'],
//       },
//       // {
//       //   component: LoaderComponent,
//       //   label: 'Loader 2',
//       //   inputs: [{ name: 'enabled', value: true }],
//       //   outputs: ['onClick'],
//       // },
//     ];
//   }
// });

@Component({
    selector: 'usimweb-tab-group',
    templateUrl: './tab-group.component.html',
    standalone: false
})
export class TabGroupComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @ViewChildren('childContainer', { read: ViewContainerRef }) childContainer!: ViewContainerRef;

  @ViewChildren('comp', { read: ViewContainerRef })
  public dynComponents!: QueryList<ViewContainerRef>;

  @Input() tabs!: GenericTab[];

  @Output() tabEvent = new EventEmitter<any>();

  private componentRef: ComponentRef<any>[] = [];

  constructor(
    private viewContainerRef: ViewContainerRef,
    private injector: Injector,
    private _resolver: ComponentFactoryResolver
  ) {}

  ngAfterViewInit(): void {
    // const componentRef = this.childContainer.createComponent(this.tabs[0].component);
    // componentRef.setInput(this.tabs[0].inputs[0].name, this.tabs[0].inputs[0].value);

    this.dynComponents.map((vcr: ViewContainerRef, index: number) => {
      const factory = this._resolver.resolveComponentFactory(this.tabs[index].component);
      const componentRef = vcr.createComponent(factory);

      this.tabs[index].inputs.forEach((input) => {
        componentRef.setInput(input.name, input.value);
      });
      this.tabs[index].outputs.forEach((output) => {
        componentRef.instance[output].subscribe((x: any) => {
          console.log(x + ': ' + index);
          this.tabEvent.emit(x);
        });
      });
    });
  }

  ngOnInit() {
    // this.loadDynamicComponent();
    // setTimeout(() => {
    //   this.tabs.forEach((tab, index: number) => {
    //     tab.inputs.forEach((input) => {
    //       this.componentRef[index]?.setInput(input.name, input.value);
    //     });
    //     tab.outputs.forEach((output) => {
    //       this.componentRef[index]?.instance[output].subscribe((x: any) => console.log(x + ': ' + index));
    //     });
    //   });
    // }, 1000);
  }

  loadDynamicComponent() {
    this.viewContainerRef.clear();

    console.log('dynamic component');
    console.log(this.tabs);

    this.tabs.forEach((tab, index: number) => {
      this.componentRef[index] = this.viewContainerRef.createComponent(tab.component);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['value']) {
    //   console.log('updated input value');
    //   console.log(this.value);
    //   setTimeout(() => {
    //     this.dynamicComponent.inputs.forEach((input) => {
    //       this.componentRef?.setInput(input.name, input.value);
    //     });
    //     this.dynamicComponent.outputs.forEach((output) => {
    //       this.componentRef?.instance[output].subscribe((x: any) => console.log(x));
    //     });
    //     // this.componentRef?.setInput('enabled', this.value); // Updated with every change from the parent component.
    //     // const enabled = this.componentRef?.instance.enabled;
    //     // console.log('is enabled');
    //     // console.log(enabled);
    //     // this.componentRef?.instance.onClick.subscribe((x: any) => console.log(x));
    //   }, 1000);
    // }
  }

  ngOnDestroy(): void {
    //this.componentRef?.destroy(); // Don't forget to destroy the component.
  }
}
